import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CommonIntegrationPage from 'components/Integration/pages/CommonIntegrationPage'
import IntegrationBreadcrumb from './components/IntegrationBreadcrumb'
import ExternalIntegration from 'components/Integration/services/ExternalIntegration'
import { INTEGRATIONS_URL, BACK_LINK_TEXT, Pages } from 'components/Integration/PageConstants'
import { PARDOT_APP_ID, ELOQUA_APP_ID } from 'constants/ResourcesConstants'
import { fetchInstalledApps } from 'app/modules/integrations/api'
import * as constants from '../../app/modules/integrations/constants'
import ACCESS from 'utils/Access'

import { fetchIntegrationStates } from 'app/modules/integrations/actions'
import { connectionsRoot, connectionsStatus } from 'app/modules/integrations/selectors'
import { createAppName } from 'components/Integration/helpers'

import defaultAppIconSrc from 'images/svg/default-app-icon.svg'
import style from './style.styl'

import { mergeAll, defaultTo } from 'ramda'


const orDefaultIconSrc = (src) => defaultTo(defaultAppIconSrc)(src)


class IntegrationsPage extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  state = {
    isLoading: true,
    pages: Pages,
    integrationIdList: []
  }

  componentDidMount() {
    this.fetchPrivateIntegrations()
    this.props.actions.fetchIntegrationStates()
  }

  fetchPrivateIntegrations = () => {
    const mapToPage = (app) => ({
      [app.id]: {
        title: app.name,
        description: app.longDescription,
        paidStatus: app.paidStatus,
        isConnected: app.installed,
        builtBy: 'PARTNER',
        logo: orDefaultIconSrc(app.iconUrl),
        Page: CommonIntegrationPage,
        Service: () => <ExternalIntegration data={app} />,
        backLinkText: BACK_LINK_TEXT,
        backLinkUrl: INTEGRATIONS_URL,
        hasRequiredAccess: () => ACCESS.hasAllOrgIntegrations()
      }
    })

    const onFetched = (apps) => {
      const privatePages = mergeAll(apps.map(mapToPage))
      const { pages } = this.state
      this.setState({
        isLoading: false,
        pages: { ...pages, ...privatePages },
        integrationIdList: apps
      })
    }

    const onError = (err) => {
      console.warn(err)
      this.setState({ isLoading: false })
    }

    fetchInstalledApps()
      .then(onFetched)
      .catch(onError)
  }

  setDriftMade = (page) => {
    page['builtBy'] = 'DRIFT'
    page['paidStatus'] = 'FREE' // free with current plan.
    return page
  }

  getPageByIntegrationId = (integrationId) => {

    const { pages, integrationIdList } = this.state

    switch (integrationId) {
      case 'pardot':
      case PARDOT_APP_ID:
        return this.setDriftMade(pages[PARDOT_APP_ID])
      case 'eloqua':
      case ELOQUA_APP_ID:
        return this.setDriftMade(pages[ELOQUA_APP_ID])
      default:
        if (integrationId.length === 36) { // get page using guid
          return pages[integrationId]
        }

        const currentIntegration = _.filter(integrationIdList, (integration) => integrationId === createAppName(integration.name))
        if (currentIntegration.length === 1){
          return pages[currentIntegration[0].id] // get dev platform page using integrationName
        }
        return pages[integrationId] // get all other integrations
    }
  }

  refreshPage() {
    window.location.reload()
  }

  render() {
    const { isLoading } = this.state
    if (isLoading) {
      return null
    }

    const { integrationConnectionStatus , integrationStates, params: { integrationId }} = this.props
    const { title, description, paidStatus, builtBy, logo, Page, Service, backLinkText, backLinkUrl, serviceClassName, hideDisconnectButton, eduTooltip, incompleteInstallEndpoint, retired, redirectPath, hasRequiredAccess } = this.getPageByIntegrationId(integrationId)

    if (!!hasRequiredAccess && !hasRequiredAccess()) {
      window.location.replace('/')
      return null
    }

    if (integrationConnectionStatus === constants.FETCH_INTEGRATION_STATES_FAILED) {
      this.refreshPage()
    }

    if (retired) {
      const host = __ENV__ === 'PRODUCTION' ? 'https://app.drift.com' : 'https://app.driftqa.com'
      document.location = `${host}${redirectPath}`
    }

    const pageProps = {
      integrationId: integrationId,
      integrationStates: integrationStates,
      Service: Service,
      paidStatus,
      builtBy,
      title: logo,
      isConnected: integrationStates[integrationId],
      description,
      logo,
      name: title,
      serviceClassName,
      hideDisconnectButton,
      EduTooltip: eduTooltip || '',
      incompleteInstallEndpoint
    }

    return (
      <div className="IntegrationListContainer">
        <IntegrationBreadcrumb
          backLinkText={backLinkText}
          backLinkUrl={backLinkUrl}
        />
        <Page {...pageProps} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  integrationStates: connectionsRoot(state) || {},
  integrationConnectionStatus : connectionsStatus(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchIntegrationStates
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationsPage)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/PageLayout.js